import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { _SetPaymentTurnCode } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";



export const PaymentTurnCode = () => {

    const SetPayment = useDataBean(_SetPaymentTurnCode);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });



    const setPaymentTurnCode = () => {

        SetPayment.instance.setPaymentTurnCode(SetPayment.bean.Year, SetPayment.bean.Code, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Código Definido');
                    setModal({ ...modal, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const vercode = () => {
        setModal({ ...modal, "view": true });

    }
    return (
        <BasicPage titulo="Configuraciones y Tareas">
            <div className="row">

                <div className="col-md-12" >
                    <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={vercode}>
                        Definir Código Actual para Turnos de Cuentas
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} eventModal={setPaymentTurnCode}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <YearSelector value={SetPayment.bean.Year} tittle="Año" onChange={(e) => SetPayment.setBean({ ...SetPayment.bean, "Year": e })} />
                                </div>
                                <div className="col-md-12">
                                    <label>Código</label>
                                    <input type="text" name="Code" className="form-control" value={SetPayment.bean.Code} onChange={(e) => SetPayment.setBean({ ...SetPayment.bean, "Code": e.target.value })} />
                                </div>
                            </div>
                        </>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}